import { render, staticRenderFns } from "./achievementsStatistics.vue?vue&type=template&id=2555c5fe&scoped=true&"
import script from "./achievementsStatistics.vue?vue&type=script&lang=js&"
export * from "./achievementsStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2555c5fe",
  null
  
)

export default component.exports